import { render, staticRenderFns } from "./BuyerAccountAddFunds.vue?vue&type=template&id=3dd0452c"
import script from "./BuyerAccountAddFunds.vue?vue&type=script&lang=js"
export * from "./BuyerAccountAddFunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports